import { render, staticRenderFns } from "./TransactionEditComponent.vue?vue&type=template&id=736f7610&"
import script from "./TransactionEditComponent.vue?vue&type=script&lang=js&"
export * from "./TransactionEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports